import type { MinigameDefinition } from '@core/types';
import { DressUpConfig } from '@modules/dressup/config';
import { DressUpScene } from '@modules/dressup/DressUpScene';

/** Definicion publica del modulo de estilo para registrarlo en el catalogo. */
export const dressUpMinigame: MinigameDefinition = {
  key: DressUpConfig.key,
  title: DressUpConfig.title,
  description: DressUpConfig.description,
  icon: DressUpConfig.icon,
  color: DressUpConfig.color,
  scene: DressUpScene,
};
